"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



// Marks the searched words inside the message a search result opened, with
// the CSS Custom Highlight API (`::highlight(search-hit)` in the thread's
// styles). It paints over the rendered text without touching the message
// components, and does nothing in a browser without the API: the message's
// ring still shows which one it is.

const HIGHLIGHT_NAME = 'search-hit'
// The text a message shows: its bubble and a file's name, not the reply quote.
const TEXT_SELECTOR = '.text-message--content, .file-message--plain--title, .file-message--media-tile--name'








const registry = () => {
  const css = (typeof CSS === 'undefined' ? undefined : CSS) 
  const Highlight = (window ).Highlight
  return _optionalChain([css, 'optionalAccess', _ => _.highlights]) && Highlight ? { highlights: css.highlights, Highlight } : null
}

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** Ranges over each match of the query's words in `root`'s message text. */
 const searchHitRanges = (root, query) => {
  const words = query.trim().split(/\s+/).filter(Boolean).map(escapeRegExp)
  if (!words.length) return []
  const matcher = new RegExp(words.join('|'), 'gi')
  const ranges = []
  root.querySelectorAll(TEXT_SELECTOR).forEach(container => {
    if (container.closest('.reply-quote')) return
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
      acceptNode: node => (_optionalChain([node, 'access', _2 => _2.parentElement, 'optionalAccess', _3 => _3.closest, 'call', _4 => _4('.reply-quote')])
        ? NodeFilter.FILTER_REJECT
        : NodeFilter.FILTER_ACCEPT),
    })
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      const text = _nullishCoalesce(node.textContent, () => ( ''))
      for (const match of text.matchAll(matcher)) {
        const range = document.createRange()
        range.setStart(node, match.index)
        range.setEnd(node, match.index + match[0].length)
        ranges.push(range)
      }
    }
  })
  return ranges
}; exports.searchHitRanges = searchHitRanges

/**
 * While `messageKey` is set, keeps the words of `query` marked in that
 * message, re-marking when the thread re-renders it (it may not be loaded
 * yet when the chat opens).
 */
 const useSearchHitHighlight = (messageKey, query) => {
  _react.useEffect.call(void 0, () => {
    const api = registry()
    if (!api || !messageKey || !query) return
    let frame = 0
    const paint = () => {
      frame = 0
      const row = document.getElementById(messageKey)
      if (!row) return
      api.highlights.set(HIGHLIGHT_NAME, new api.Highlight(...exports.searchHitRanges.call(void 0, row, query)))
    }
    paint()
    const observer = new MutationObserver(() => {
      if (!frame) frame = window.requestAnimationFrame(paint)
    })
    const thread = _nullishCoalesce(document.querySelector('.chat--messagingSection'), () => ( document.body))
    observer.observe(thread, { childList: true, subtree: true, characterData: true })
    return () => {
      observer.disconnect()
      if (frame) window.cancelAnimationFrame(frame)
      api.highlights.delete(HIGHLIGHT_NAME)
    }
  }, [messageKey, query])
}; exports.useSearchHitHighlight = useSearchHitHighlight
